export class ActivityFilters {
    name: string;

    constructor() {}
}
